"use client"

import { richTextRender } from '@lib/rich-text-base'
import type { TypeVideoPlayerFields } from '@lib/generated-types'
import { ComponentPropsWithoutRef,useCallback, useEffect, useState } from 'react'
import { VideoPlayer as Block } from '@shc/ui'
import { startYouTubeTracking } from '@snowplow/browser-plugin-youtube-tracking'
import { getYoutubeVideoIdFromUrl } from '@lib/utilities/video-utilities'


interface VideoPlayerBlockProps extends ComponentPropsWithoutRef<'div'>, TypeVideoPlayerFields {
  showCaption: boolean
  videoUrl?: string
  autoPlay?: boolean
  fullScreen?: boolean
  loop?: boolean
}

const VideoPlayerBlock = ({
  videoUrl,
  caption,
  showCaption = true,
  fullScreen = false,
  autoPlay = false,
  loop = false,
}: VideoPlayerBlockProps) => {
  const [isFullScreen, setisFullScreen] = useState(fullScreen)

  const videoId = getYoutubeVideoIdFromUrl(videoUrl)

  const escFunction = useCallback(
    (event: KeyboardEvent) => {
      if (fullScreen)
        if (event.key === 'Escape') {
          setisFullScreen(false)
        } else if (event.key === ' ') {
          setisFullScreen(true)
        }
    },
    [fullScreen]
  )

  useEffect(() => {
    document.addEventListener('keydown', escFunction, true)
    return () => {
      document.removeEventListener('keydown', escFunction, true)
    }
  }, [escFunction])

  return (
    <Block
      iframeId={videoId}
      id={videoId}
      description={showCaption && caption && richTextRender(caption)}
      url={videoUrl}
      autoPlay={autoPlay}
      loop={loop}
      onReady={() => {
        if (videoId) {
          startYouTubeTracking({
            id: videoId,
            video: videoId,
            captureEvents: ['play', 'pause', 'end', 'percent_progress', 'error'],
          })
        } else {
          console.error('Cannot find YouTube video ID to track analytics')
        }
      }}      
    />
  )
}

export default VideoPlayerBlock
